module.exports = __webpack_public_path__ + "img/26.ca3c4b26.png";